export default __webpack_public_path__ + "static/media/hospitalLogo.8c2794e4.png";